export default "__VITE_ASSET__ea85e243__"